import { functionService } from "../../lib/functions";
import { useNavigate } from "react-router-dom";
import * as Styled from "./styles";
import { useState } from 'react';

const CompanyLogin = () => {
    const [email, setEmail] = useState('');
    const navigate = useNavigate(); 
    
    function generateOtp() {
        const otp = Math.floor(1000 + Math.random() * 9000);
        return otp.toString(); 
      }
    const isMailExist = async () => {
        try {
            let response = await functionService.isEmailExist({ email: email });
            if (response.response.data.data[0].email_exists == 'true') { 
                localStorage.setItem("userEmail", email);
                const otp = generateOtp();
                try{
                    let response = await functionService.sendCompanyCode({code:otp,email:email});
                     if(response.status){
                        console.log("Otp sent successfully");
                     }

                }
                catch(err){
                  console.log(err.message)
                }
                try{
                    let response = await functionService.sendOtpMailToCompany({code:otp,email:email});
                     if(response.status){
                        console.log("Otp sent successfully");
                     }

                }
                catch(err){
                  console.log(err.message)
                }

                navigate('/provide-otp');
                setEmail('');
            }
        } catch (err) {
            console.log(err.message);
        }
    }

    const handleOk = () => {
        isMailExist();
    }

    return (
        <Styled.MainDiv>
            <div className="left_container">
                <div className="parentDiv">
                    <div className="head">Let's view the candidate profile and shortlist them</div>
                    <div className="head1">Your official email address</div>
                    <input 
                        className="head2" 
                        onChange={(e) => setEmail(e.target.value)} 
                        value={email} // Optionally bind value to state
                    />
                    <button onClick={handleOk}>Continue</button>
                </div>
            </div>
            <div className="right_container">
                <div></div>
            </div>
        </Styled.MainDiv>
    )
}

export default CompanyLogin;
